import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LufcCustomerRegisterAdapter } from './lufc-customer-register.adapter';

@Injectable()
export class LufcCustomerRegisterConnector {
  constructor(protected adapter: LufcCustomerRegisterAdapter) {}

  addLufcId(lufcId: string): Observable<string> {
    return this.adapter.addLufcId(lufcId);
  }

  getLufcId(): Observable<string> {
    return this.adapter.getLufcId();
  }
}
